import { createContext, useContext } from 'react'
import type { EntityDef } from '../api/types'

export type ModifyDateMode = 'preset' | 'custom'

/** Same presets Export offers — Modify reuses Export's query builder server-side. */
export const MODIFY_DATE_PRESETS = [
  'This fiscal year',
  'Last fiscal year',
  'This quarter',
  'Last quarter',
  'This month',
  'Last month',
]

export interface ModifyDraft {
  entityType: string
  entity: EntityDef | null
  /** The entity-specific filter box, e.g. a document number or display name. */
  reference: string
  dateMode: ModifyDateMode
  preset: string
  from: string
  to: string
}

export interface ModifyWizard extends ModifyDraft {
  entities: EntityDef[]
  /** The active company's id, or null before any company is connected. */
  companyId: string | null
  setEntityType: (name: string) => void
  setReference: (value: string) => void
  setDateMode: (mode: ModifyDateMode) => void
  setPreset: (preset: string) => void
  setFrom: (value: string) => void
  setTo: (value: string) => void
  reset: () => void
}

export const ModifyWizardContext = createContext<ModifyWizard | null>(null)

export function useModifyWizard(): ModifyWizard {
  const context = useContext(ModifyWizardContext)
  if (!context) throw new Error('useModifyWizard must be used inside the modify route')
  return context
}
